export default "__VITE_ASSET__MxYGkGnl__"